/**
 * @file supportData.js
 * @description 문의하기 폼의 문의 유형 목록과 개인정보 수집 동의 문구를 정의합니다.
 * @used-in pages/cs/ContactPage.jsx, hooks/useContactForm.js, components/contact/ContactFormPanel.jsx
 * @migrated-from src/App.js
 */

export const inquiryTypes = ['견적문의', '유지보수', '기타'];

export const privacyPolicyText =
  '문의 접수 및 답변 안내를 위해 회사명, 담당자명, 연락처, 이메일 등 입력하신 정보를 수집합니다. 수집된 정보는 문의 대응 목적에 한하여 사용되며, 관련 법령 또는 내부 기준에 따라 안전하게 관리됩니다. 이용자는 개인정보 수집 및 이용 동의를 거부할 수 있으나, 이 경우 문의 접수가 제한될 수 있습니다.';
